module.exports = __webpack_public_path__ + "img/16581267_L.f00638c3.png";